import React from 'react';
import './Footer.css';
import { FaWhatsapp, FaInstagram, FaLinkedinIn, FaYoutube, FaTelegram } from 'react-icons/fa';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-content">
                <div className="social-media">
                    <p>Let's get social:</p>
                    <div className="social-icons">
                        <a href="https://chat.whatsapp.com/KqeGz58KHTJ1NfrnT5WkeX" target="_blank" rel="noopener noreferrer"><FaWhatsapp /></a>
                        <a href="https://www.instagram.com/futuremedsacademy" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
                        <a href="https://www.linkedin.com/in/amir-akhtar-92644a33a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a>
                        <a href="https://youtube.com/@meddreamsabroad?si=c2o7s-AZ-nW4XWWN" target="_blank" rel="noopener noreferrer"><FaYoutube /></a>
                        <a href="https://t.me/imat2025fma" target="_blank" rel="noopener noreferrer"><FaTelegram /></a>
                    </div>
                </div>

                <div className="contact-info">
                    <p>Contact Us:</p>
                    <a href="mailto:Info@futuremedsacademy.com">Info@futuremedsacademy.com</a>
                </div>

                <div className="reach-out">
                    <p>Reach out to us:</p>
                    <p>Get your questions answered about learning with Us</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
